import React from "react";
import { Box, Button } from "@mui/material";

const FooterButtons = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "1rem",
          marginTop: "2rem",
          paddingBottom: "5rem",
        }}
      >
        <Button variant="contained" href="/contact-us" sx={{ minWidth: 120 }}>
          Contact Us
        </Button>
        <Button
          variant="contained"
          href="/terms-and-conditions"
          sx={{ minWidth: 120 }}
        >
          Terms and Conditions
        </Button>
        <Button
          variant="contained"
          href="/privacy-policy"
          sx={{ minWidth: 120 }}
        >
          Privacy Policy
        </Button>
        <Button
          variant="contained"
          href="/cancellation-and-refund-policy"
          sx={{ minWidth: 120 }}
        >
          Cancellation & Refund Policy
        </Button>
        <Button
          variant="contained"
          href="/shipping-and-delivery"
          sx={{ minWidth: 120 }}
        >
          Shipping & Delivery
        </Button>
      </Box>
    </>
  );
};

export default FooterButtons;
